export const environmentService = {
  apiUrlAvailability: 'https://api.dtt.travel/availability',
  apiUrlAuth: 'https://api.dtt.travel/users/auth',
  apiUrlUser: 'https://api.dtt.travel/users',
  apiUrlBooking: 'https://api.dtt.travel/bookings',
  apiUrlHotel: 'https://api.dtt.travel/hotels',
  apiUrlRatePlan: 'https://api.dtt.travel/rates',
  apiUrlLogs: 'https://api.dtt.travel/logs',
  apiUrlIntegration: 'https://api.dtt.travel/integration',
  apiUrlMails: 'https://api.dtt.travel/mails',
  sentryDsn: "https://c202e475529d4a71891958c3fba739be@o1294242.ingest.sentry.io/6518017",
  sentrySiteUrl: "https://demo.dtt.travel",

  production: true,
}



// WEBPACK FOOTER //
// ./src/utils/services/environments/environment.service.js